export default {
    session_list: null
};
